import { t } from '@ankr.com/common';

import { SignInButton } from 'modules/auth/components/SignInButton';

import { CenterContainer } from '../CenterContainer';
import { InfoCard } from '../InfoCard';

export const ConnectWalletCard = () => {
  return (
    <CenterContainer>
      <InfoCard
        align="center"
        description={t('user-settings.connect-wallet-card.description')}
        title={t('user-settings.connect-wallet-card.title')}
      >
        <SignInButton>
          {t('user-settings.connect-wallet-card.button')}
        </SignInButton>
      </InfoCard>
    </CenterContainer>
  );
};
